let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("hAfMz")).then(() => parcelRequire('78QGM'));